
<div class="row">
    <div class="flex-half">
        <select-search-component
            [value]="config.process"
            [classes]="'fill'"
            [api_model]="'process_light'"
            (selectionChange)="processChange($event)"
            [label]="'Select a process'"
        class="select-search">
        </select-search-component>
    </div>
 <div class="row flex-half">
    <mat-form-field>
      <mat-label>Hidden Columns</mat-label>
      <mat-select [(value)]="config.hidden_columns" multiple>
        <mat-option value="description">Description</mat-option>
        <mat-option value="parent_name">Component</mat-option>
        <mat-option value="report_group">Group</mat-option>
        <mat-option value="base_type">Type</mat-option>
        <mat-option value="sample_period">Sample Period</mat-option>
      </mat-select>
    </mat-form-field>
</div>
</div>
